import { useAppSelector } from "../../redux/redux";
import { useGetOrgQuery } from "../../services/OrgService";
import { getLinkedFirm } from "../../sessionStorage/sessionStorage";
import { Region, regionOf } from "./region";

/** The signed-in firm's country (Settings > Company); Canada until loaded. */
export const useFirmRegion = (): Region => {
  const orgId = getLinkedFirm()?.orgId || "";
  const { data: org } = useGetOrgQuery(orgId, { skip: !orgId });
  return regionOf(org?.locations?.[0]?.locationAddress?.country);
};

/** Only Admins may change the firm's country (owner, 2026-10-24). */
export const useIsFirmAdmin = (): boolean => {
  const { user } = useAppSelector((state) => state.appReducer);
  return user?.userRoleEnum?.userRole === "Admin";
};
